import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddStocksComponent } from './addStock/addstocks.component';
import { CreateOrEditAddStockComponent } from './addStock/create-or-edit-addstock.component';
import { StockAdjustmentComponent } from './stockAdjustment/stockadjustments.component';
import { CreateOrEditStockAdjustmentComponent } from './stockAdjustment/create-or-edit-stockadjustment.component';
import { StockTransferComponent } from './stockTransfer/stocktransfer.component';
import { CreateOrEditStockTransferComponent } from './stockTransfer/create-or-edit-stocktransfer.component';
import { StockReceiveComponent } from './stockReceive/stockreceive.component';
import { CreateOrEditStockReceiveComponent } from './stockReceive/create-or-edit-stockreceive.component';
import { StockTakesComponent } from './stockTake/stocktakes.component';
import { CreateOrEditStockTakeModalComponent } from './stockTake/create-or-edit-stocktake-modal.component';
import { EditStockItemModalComponent } from './stockTake/edit-stock-item-modal.component';
import { CreateOrEditStockItemsComponent } from './stockTake/create-or-edit-stock-items.component';
import { ProductionsComponent } from './production/productions.component';
import { CreateOrEditProductionComponent } from './production/create-or-edit-production.component';
import { StockAdjustmentTypesComponent } from './stockAdjustmentType/stockAdjustmentTypes.component';
import { CreateOrEditStockAdjustmentTypeModalComponent } from './stockAdjustmentType/create-or-edit-stockAdjustmentType-modal.component';



const routes: Routes = [
    {
        path: 'stockAdjustmentTypes',
        children: [
            {
                path: '',
                component: StockAdjustmentTypesComponent, // list
            },
            {
                path: 'createOrEdit',
                component: CreateOrEditStockAdjustmentTypeModalComponent,
            }
        ]
    },
    {
        path: 'addStocks',
        children: [
            {
                path: '',
                component: AddStocksComponent, // list
            },
            {
                path: 'createOrEdit',
                component: CreateOrEditAddStockComponent,
            }
        ]
    },
    {
        path: 'stockAdjustments',
        children: [
            {
                path: '',
                component: StockAdjustmentComponent, // list
            },
            {
                path: 'createOrEdit',
                component: CreateOrEditStockAdjustmentComponent,
            }
        ]
    },
    {
        path: 'stocktransfer',
        children: [
            {
                path: '',
                component: StockTransferComponent, // list
            },
            {
                path: 'createOrEdit',
                component: CreateOrEditStockTransferComponent,
            }
        ]
    },
    {
        path: 'stockreceive',
        children: [
            {
                path: '',
                component: StockReceiveComponent, // list
            },
            {
                path: 'createOrEdit',
                component: CreateOrEditStockReceiveComponent,
            }
        ]
    },
    {
        path: 'stocktakes',
        children: [
            {
                path: '',
                component: StockTakesComponent, // list
            },
            {
                path: 'createOrEdit',
                component: CreateOrEditStockTakeModalComponent,
            },
            {
                path: 'editstockitem',
                component: EditStockItemModalComponent,
            },
            {
                path: 'addstockitem',
                component: CreateOrEditStockItemsComponent,
            }
        ]
    },
    {
        path: 'productions',
        children: [
            {
                path: '',
                component: ProductionsComponent, // list
            },
            {
                path: 'createOrEdit',
                component: CreateOrEditProductionComponent,
            }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class StockRoutingModule { }
